module.exports = {
      id: "icon-open-in-new-usage",
      viewBox: "0 0 24.047 24.047",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-open-in-new",
      toString: function () {
        return this.url;
      }
    }